import { html } from 'lit';
const Blocksuite =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M20 8.182 14.703 4 4 6.121v9.696L9.298 20 20 17.88zm-6.356-2.65v2.754l1.62-.32v-1.71l2.34 1.846-7.81 1.548-3.398-2.682zM5.62 8.167l3.116 2.459v2.887l1.62-.32V10.86l8.024-1.59v6.564l-3.116-2.46v-2.886l-1.62.32v2.332L5.62 14.73zm4.736 10.301v-2.754l-1.62.321v1.71L6.396 15.9l7.811-1.548 3.397 2.681z"/>
  </svg>
`;
export default Blocksuite;
